import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Container,
    Col,
    Row,
    Button,
} from 'reactstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../context';

const ResetPracticeConversionModal = () => {

    const { offeringName, conversionId } = useSelector(state => ({
        offeringName: state.conversions.modalConversion?.offering,
        conversionId: state.conversions.modalConversion?.id
    }), shallowEqual);

    const toggleModal = (bool) => {
        dispatch(actions.toggle.toggleResetConversionModalOpen(bool));
    }
    const isOpen = useSelector(state => state.toggle.isResetConversionModalOpen);
    const dispatch = useDispatch();

    const closeModal = () => toggleModal(false);

    const handleDelete = () => {
        dispatch(
            actions.conversions.resetConversion(conversionId)
        ).then(() => {
            dispatch(actions.toggle.triggerPracticeRefresh());
            dispatch(actions.toggle.activitiesRefresh());
            closeModal();
        });
    };

    return (
         <Modal
            isOpen={isOpen}
            toggle={() => isOpen && closeModal}
            className="modal-md text-light"
            contentClassName="bg-secondary"
            centered={true}
            style={{ minWidth: '30vw' }}>
            <ModalHeader className="d-inline-block w-100 h-100">
                <Row>
                    <Col className="d-inline-block w-100 h-100">
                        <h4>Reset this "{offeringName}" conversion?</h4>
                    </Col>
                </Row>
            </ModalHeader>
            <ModalBody className="justify-content-center">
                <Container>
                    <Row>
                        <Col>
                            <p>Are you sure you want to reset this conversion?</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            "{offeringName}" Conversion
                        </Col>
                    </Row>
                </Container>
            </ModalBody>
            <ModalFooter className="justify-content-right">
                <Button
                    color="info"
                    onClick={closeModal}>
                    Cancel
                </Button>
                <Button color="danger" onClick={handleDelete}>
                    Reset
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ResetPracticeConversionModal;